import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';

import {CoreModule} from '@core/core.module';
import {SharedModule} from '@shared/shared.module';
import {DemoMaterialModule} from '@src/app/material-module';
import {UserGuideComponent} from './components/user-guide/user-guide.component';
import {UserGuideAccordionComponent} from './components/user-guide-accordion/user-guide-accordion.component';
import {UserGuideAccordionItemComponent} from './components/user-guide-accordion-item/user-guide-accordion-item.component';
import {UserGuideDrawerComponent} from './components/user-guide-drawer/user-guide-drawer.component';
import {UserGuideHintComponent} from './components/user-guide-hint/user-guide-hint.component';
import {UserGuideOverlayComponent} from './components/user-guide-overlay/user-guide-overlay.component';
import {SignUpModalComponent} from './modals/sign-up-modal/sign-up-modal.component';
import {UserGuideAdditionalElementsComponent} from './components/user-guide-additional-elements/user-guide-additional-elements.component';

@NgModule({
  entryComponents: [SignUpModalComponent],
  declarations: [
    UserGuideComponent,
    UserGuideAccordionComponent,
    UserGuideAccordionItemComponent,
    UserGuideDrawerComponent,
    UserGuideHintComponent,
    UserGuideOverlayComponent,
    UserGuideAdditionalElementsComponent,
    SignUpModalComponent,
  ],
  imports: [
    CoreModule,
    SharedModule,
    CommonModule,
    DemoMaterialModule,
    FormsModule,
    ReactiveFormsModule,
  ],
  exports: [UserGuideComponent],
  providers: [],
})
export class UserGuideModule {}
